import { addDays, addMonths, subMonths } from "date-fns";

// DEMONSTRATION DATA ONLY — replaced by authenticated API data in Stage 2.
export const makeDemo = () => {
  const today = new Date();
  const nextBilling = addDays(today, 12);
  const nextDelivery = addDays(nextBilling, 5);
  const past = [1, 2, 3].map((n) => ({ billed: subMonths(nextBilling, n), delivered: subMonths(nextDelivery, n) }));
  return {
    customer: {
      name: "Demo Customer",
      email: "demo.customer@example.com",
      phone: "07700 900000",
      address: { line1: "12 Example Road", line2: "", town: "Ballyclare", postcode: "BT39 0AA" },
      instructions: "Please leave beside the side gate.",
    },
    subscription: { plan: "regular", nextBilling, nextDelivery, pause: null, cancelsOn: null, pendingPlan: null, skipped: false },
    deliveries: past.map((p, i) => ({ id: `DEMO-D${103 - i}`, date: p.delivered, plan: "Regular", status: "Delivered" })),
    payments: past.map((p, i) => ({ id: `DEMO-INV-${203 - i}`, date: p.billed, amount: 6499, status: "Paid" })),
  };
};

export const shiftMonths = (sub, n) => ({
  ...sub,
  nextBilling: addMonths(sub.nextBilling, n),
  nextDelivery: addMonths(sub.nextDelivery, n),
});
